import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from './App';
import { useNavigate } from 'react-router-dom';
import { FaTimes, FaGift, FaBan } from 'react-icons/fa';
import './DepositForm.css';

const DepositForm = ({ isOpen = true, onClose }) => {
  const navigate = useNavigate();
  const { user, setIsRedeemModalOpen, setIsWithdrawModalOpen } = useContext(UserContext);
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('BTC');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [promoCode, setPromoCode] = useState('');

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  const cryptoCurrencies = [
    { value: 'BTC',  name: 'Bitcoin',         sub: '',       img: '/Bitcoin.png' },
    { value: 'ETH',  name: 'Ethereum',        sub: '(ERC20)',img: '/ethereum.png' },
    { value: 'LTC',  name: 'Litecoin',        sub: '',       img: '/litecoin.png' },
    { value: 'SOL',  name: 'Solana',          sub: '',       img: 'https://cryptologos.cc/logos/solana-sol-logo.png' },
    { value: 'USDT', name: 'USDT',            sub: '(ERC20)',img: '/tether.png' },
    { value: 'TRX',  name: 'TRON',            sub: '',       img: 'https://cryptologos.cc/logos/tron-trx-logo.png' },
  ];

  const handleDeposit = async (selectedCurrency) => {
    const cur = selectedCurrency || currency;
    if (!amount || parseFloat(amount) < 1) {
      setMessage({ text: 'Minimum deposit is $1', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('https://test3-0ar4.onrender.com/api/payment/deposit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ amount: parseFloat(amount), currency: cur })
      });
      const data = await response.json();
      if (response.ok && data.deposit_url) {
        setMessage({ text: 'Redirecting to payment gateway...', type: 'success' });
        setTimeout(() => { window.location.href = data.deposit_url; }, 1500);
      } else {
        setMessage({ text: data.error || 'Payment gateway error.', type: 'error' });
      }
    } catch (error) {
      setMessage({ text: 'Network connection issue.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (onClose) onClose();
    else navigate('/dashboard');
  };

  if (!isOpen) return null;

  return (
    <div className="dp-overlay" onClick={handleClose}>
      <div className="dp-modal" onClick={e => e.stopPropagation()}>

        {/* ── Top action bar ── */}
        <div className="dp-topbar">
          <div className="dp-topbar-left">
            <button className="dp-tab dp-tab-active">
              + Deposit
            </button>
            <button
              className="dp-tab"
              onClick={() => {
                handleClose();
                if (setIsWithdrawModalOpen) setIsWithdrawModalOpen(true);
              }}
            >
              ↑ Withdraw
            </button>
          </div>
          <div className="dp-topbar-right">
            <button
              className="dp-promo-btn"
              onClick={() => {
                handleClose();
                if (setIsRedeemModalOpen) setIsRedeemModalOpen(true);
              }}
            >
              <FaGift style={{ marginRight: 6 }} /> Promo Code
            </button>
            <button className="dp-close-btn" onClick={handleClose}>
              <FaTimes />
            </button>
          </div>
        </div>

        {/* ── Main content ── */}
        <div className="dp-content">
          <div className="dp-left">
            {message && (
              <div className={`dp-alert ${message.type}`}>
                {message.type === 'error' ? '⚠ ' : '✓ '}{message.text}
              </div>
            )}

            {/* Steam Skins */}
            <div className="dp-section-title">Steam Skins</div>
            <div className="dp-grid dp-grid-2">
              <div className="dp-card dp-disabled">
                <div className="dp-disabled-overlay">
                  <FaBan className="dp-ban-icon" />
                  <span>Not Available</span>
                </div>
                <div className="dp-card-img dp-card-img-rust">
                  <img src="https://upload.wikimedia.org/wikipedia/en/thumb/e/e4/Rust_game_logo.png/250px-Rust_game_logo.png" alt="Rust" />
                </div>
                <div className="dp-card-label">Rust</div>
              </div>
              <div className="dp-card dp-disabled">
                <div className="dp-disabled-overlay">
                  <FaBan className="dp-ban-icon" />
                  <span>Not Available</span>
                </div>
                <div className="dp-card-img dp-card-img-cs2">
                  <img src="https://upload.wikimedia.org/wikipedia/en/f/f2/CS2_logo.png" alt="CS2" />
                </div>
                <div className="dp-card-label">CS2</div>
              </div>
            </div>

            {/* Real Cash */}
            <div className="dp-section-title">
              Real Cash
            </div>
            <div className="dp-grid dp-grid-3">
              <div className="dp-card dp-disabled">
                <div className="dp-disabled-overlay">
                  <FaBan className="dp-ban-icon" />
                  <span>Not Available</span>
                </div>
                <div className="dp-card-img">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/320px-Visa_Inc._logo.svg.png" alt="Visa" style={{ width: 60 }} />
                </div>
                <div className="dp-card-label">Credit Card <span className="dp-sub">(Swapped)</span></div>
                <span className="dp-new-badge">NEW</span>
              </div>
              <div className="dp-card dp-disabled">
                <div className="dp-disabled-overlay">
                  <FaBan className="dp-ban-icon" />
                  <span>Not Available</span>
                </div>
                <div className="dp-card-img">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/320px-PayPal.svg.png" alt="PayPal" style={{ width: 80 }} />
                </div>
                <div className="dp-card-label">PayPal <span className="dp-sub">(Kinguin)</span></div>
              </div>
              <div className="dp-card dp-disabled">
                <div className="dp-disabled-overlay">
                  <FaBan className="dp-ban-icon" />
                  <span>Not Available</span>
                </div>
                <div className="dp-card-img">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/320px-PayPal.svg.png" alt="PayPal" style={{ width: 80 }} />
                </div>
                <div className="dp-card-label">PayPal <span className="dp-sub">(Pulse)</span></div>
              </div>
            </div>

            {/* Crypto Currencies */}
            <div className="dp-section-title">
              Crypto Currencies
            </div>
            <div className="dp-grid dp-grid-5">
              {cryptoCurrencies.map(c => (
                <div
                  key={c.value}
                  className={`dp-card dp-crypto-card ${currency === c.value ? 'dp-card-active' : ''}`}
                  onClick={() => setCurrency(c.value)}
                >
                  <div className="dp-crypto-icon">
                    <img src={c.img} alt={c.name} />
                  </div>
                  <div className="dp-card-label">
                    {c.name} {c.sub && <span className="dp-sub">{c.sub}</span>}
                  </div>
                </div>
              ))}
            </div>

            {/* Amount input shown when crypto selected */}
            {['BTC','ETH','LTC','SOL','USDT','TRX'].includes(currency) && (
              <form onSubmit={e => { e.preventDefault(); handleDeposit(); }} className="dp-amount-form">
                <div className="dp-amount-row">
                  <div className="dp-amount-input-wrap">
                    <span className="dp-prefix">$</span>
                    <input
                      type="number"
                      className="dp-amount-input"
                      value={amount}
                      onChange={e => setAmount(e.target.value)}
                      placeholder="0.00"
                      min="1"
                      step="0.01"
                    />
                  </div>
                  <div className="dp-quick-row">
                    {[10, 25, 50, 100].map(val => (
                      <button key={val} type="button" className="dp-quick-btn" onClick={() => setAmount(val.toString())}>
                        ${val}
                      </button>
                    ))}
                  </div>
                </div>
                <button type="submit" className="dp-submit-btn" disabled={loading || !amount || parseFloat(amount) < 1}>
                  {loading ? 'Processing...' : `Deposit $${parseFloat(amount || 0).toFixed(2)} via ${currency}`}
                </button>
              </form>
            )}
          </div>

          {/* ── Right: Affiliate code ── */}
          <div className="dp-right">
            <div className="dp-affiliate-box">
              <div className="dp-affiliate-title">
                Affiliate code <span className="dp-badge dp-badge-green">+3%</span>
              </div>
              <div className="dp-affiliate-input-row">
                <input
                  type="text"
                  className="dp-affiliate-input"
                  placeholder="Enter a code and receive..."
                  value={promoCode}
                  onChange={e => setPromoCode(e.target.value)}
                />
                <button 
                  className="dp-affiliate-apply" 
                  onClick={async (e) => {
                    e.preventDefault();
                    if (!promoCode) return;
                    try {
                      const token = localStorage.getItem('token');
                      const response = await fetch('https://test3-0ar4.onrender.com/api/referral/apply', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ referralCode: promoCode })
                      });
                      const data = await response.json();
                      if (response.ok) {
                        setMessage({ text: 'Affiliate code applied successfully!', type: 'success' });
                        setPromoCode('');
                      } else {
                        setMessage({ text: data.error || 'Failed to apply code.', type: 'error' });
                      }
                    } catch (error) {
                      setMessage({ text: 'Network connection issue.', type: 'error' });
                    }
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositForm;
